import { get } from '../../../Services/API';

/**
   * Fetch orders
   * @param {object} appliedFilters
   * @param {object} params  query parameters beside the filters, for a view
   *   that needs more of each booking (`with_estimated_end`)
   */
export default ({
  setFiltered,
  setIsLoading,
  setOrders,
  setTotalPages,
  setTotalOrders,
  setError,
}) => async (appliedFilters, params = {}) => {
  // This used to scroll to the top of the page. Reading the list is not
  // always a page turn, though: it is also the reload after archiving a row,
  // the Refresh button, and the first read after Back — where ScrollMemory
  // has just put the reader back on the row they were looking at, only for
  // this to throw them to the top again. The page turn, the one case that
  // meant it, now scrolls for itself in the table's pager.
  if (setFiltered) {
    setFiltered(false);
  }

  setIsLoading(true);
  try {
    const response = await get('/bookings', { ...params, filters: appliedFilters });
    setOrders(response.data?.data?.documents || []);
    setTotalPages(response.data?.data?.pages || 1);

    if (setTotalOrders) setTotalOrders(response.data?.data?.count);
  } catch (err) {
    setError(err.message);
  } finally {
    setIsLoading(false);
  }
};
